const filters = document.querySelector('.portfolio-filter');
const filterItems = document.querySelectorAll('.portfolio-filter__input');
const portfolioItems = document.querySelectorAll('.portfolio-item');
const selectedFilterHolder = document.querySelector('.portfolio-filter__selected');

export default function portfolioFilter () {
    if ( filterItems.length === 0 ) return;

    document.addEventListener('DOMContentLoaded', filterPortfolioItems);
    document.addEventListener('DOMContentLoaded', setupMobileFilter);

    document.querySelector('.portfolio-filter__holder')
        .addEventListener('click', evt => {
            const current = evt.target.closest('.portfolio-filter__input');

            if ( current ) {
                // Disable other filters
                filterItems.forEach(input => {
                    if ( input !== current ) {
                        input.checked = false;
                    }
                });

                filterPortfolioItems();
                showCategoryContent();
                filters.classList.remove('active');
            }
        });
}

function showCategoryContent () {
    const selectedFilter = [...filterItems].find(input => input.checked === true);

    const content = document.querySelectorAll('.category-content__item');
    content.forEach(item => item.classList.remove('active'));

    if ( !selectedFilter ) return;

    const selectedCategory = selectedFilter.value;
    const current = [...content].find(item => item.dataset.category === selectedCategory);

    if ( current ) current.classList.add('active');
}

function filterPortfolioItems () {
    const selectedFilter = [...filterItems].find(input => input.checked === true);

    selectedFilterHolder.innerHTML = '';

    if ( !selectedFilter ) {
        // Show all items if no filter is selected
        portfolioItems.forEach(portfolioItem => {
            portfolioItem.classList.remove('portfolio-item--hidden', 'portfolio-item--reverse');
            portfolioItem.style.order = '';
        });
        setCategoryUrl();
    } else {
        setCategoryUrl(selectedFilter.value);

        selectedFilterHolder.appendChild(selectedFilter.parentNode.cloneNode(true));

        portfolioItems.forEach((portfolioItem, index) => {
            const categories = JSON.parse(portfolioItem.getAttribute('data-categories'));
            const order = categories[selectedFilter.value];

            if ( order ) {
                portfolioItem.classList.remove('portfolio-item--hidden');
                portfolioItem.style.order = order;
            } else {
                portfolioItem.classList.add('portfolio-item--hidden');
                portfolioItem.classList.remove('portfolio-item--reverse');
                portfolioItem.style.order = '';
            }
        });

        [...portfolioItems]
            .filter(portfolioItem => !portfolioItem.classList.contains('portfolio-item--hidden'))
            .sort((a, b) => a.style.order - b.style.order)
            .forEach((portfolioItem, index) => {
                if (index % 2) {
                    portfolioItem.classList.add('portfolio-item--reverse');
                }
            });
    }
}


function setCategoryUrl (category) {
    const url = new URL(window.location);

    if ( category ) {
        url.searchParams.set('category', category);
    } else {
        url.searchParams.delete('category');
    }

    window.history.pushState({}, '', url);
}



function setupMobileFilter () {
    const filterToggle = document.querySelector('.portfolio-filter__label');

    filterToggle.addEventListener('click', () => {
        filters.classList.toggle('active');
    })
}
